
import { Options, setup, Vue } from "vue-class-component";
import { computed, defineAsyncComponent } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";
import { useMeta } from "vue-meta";

import { Bar } from "vue-chartjs";
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, BarElement, CategoryScale, LinearScale } from "chart.js";

ChartJS.register( Title, Tooltip, ArcElement, Legend, BarElement, CategoryScale, LinearScale );


@Options( {
  components : {
    Bar,
    Header : defineAsyncComponent( () => import("@/components/Header.vue") ),
    Footer : defineAsyncComponent( () => import("@/components/Footer.vue") )
  }
} )
export default class extends Vue
{
  store = useStore( key );

  regions = [];

  charts = {};

  meta = setup( () => useMeta( computed( () => {
    return {
      title       : [{
        content : "Location garde meuble par région - Location-gardemeuble.fr",
        vmid    : "title",
        name    : "title"
      }],
      description : {
        content : "Choisissez facilement un box de stockage ou un garde meuble dans votre région, en France. On vous invite à découvrir toute une collection d’enseignes.",
        vmid    : "description",
        name    : "description"
      }
    };
  } ) ) );

  private getRegionNames()
  {
    return this.regions.map( ( region : any ) => region.name );
  }

  private getRegionPrices()
  {
    return this.regions.map( ( region : any ) => region.price );
  }

  mounted()
  {
    let request = fetch( this.store.state.api + "region", {
      method  : "GET",
      cache   : "no-cache",
      headers : {
        "Content-Type" : "application/json",
        "Accept"       : "application/json"
      }
    } );

    request.then( ( res ) => { return res.json(); } ).then( ( json ) => {
      this.regions = json.data;
      this.charts  = {
        data    : {
          labels   : this.getRegionNames(),
          datasets : [
            {
              data            : this.getRegionPrices(),
              backgroundColor : [
                "rgb(49, 54, 140)"
              ]
            }
          ]
        },
        options : {
          animations          : false,
          indexAxis           : "y",
          scales              : {
            y : {
              ticks : {
                color : "black",
                font  : {
                  size : 13
                }
              },
              grid  : {
                display : false
              }
            }
          },
          plugins             : {
            legend : {
              display : false
            },
            tooltip : {
              callbacks : {
                label : ( item : any ) =>
                  `Prix : ${item.formattedValue} € / m² en moyenne`
              }
            }
          }
        }
      };
    } );
    request.catch( ( error ) => console.log( error ) );

    setTimeout( () => {
      this.store.state.loading = false;

      // Remove div#preload from DOM
      let preload = document.getElementById( "preload" );
      if( preload )
      {
        window.scrollTo( { top : 0 } );
        preload.remove();
      }
    }, this.store.state.delay );
  }
}
